module.exports = __webpack_public_path__ + "img/bg-2@2x.13ac57c4.png";